<template>
  <table :class="tableClasses">
    <tbody class="tbody tbody-virtual">
      <AppSlotOutlet
        :slot-fn="rowSlot"
        :scope="{ index: index || 0, row: source }"
      />
    </tbody>
  </table>
</template>

<script>
// Row renderer for ReportVirtualTableBody's virtual list.
//
// vue3-virtual-scroll-list renders each row through `data-component` (it does NOT
// consume a `#item` slot). ReportVirtualTableBody passes us the row data as `source`,
// the table classes, and its own default slot (as `rowSlot`) via `extra-props`.
import AppSlotOutlet from '~/components/AppSlotOutlet.vue';

export default {
  name: 'ReportVirtualTableRow',
  components: { AppSlotOutlet },
  props: {
    source: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    tableClasses: {
      type: [Array, String, Object],
      default: '',
    },
    rowSlot: {
      type: Function,
      default: null,
    },
    // Absorbs the prop the virtual list passes to every row component so it
    // doesn't leak onto the DOM as a `scopedslots` attribute.
    scopedSlots: {
      type: Object,
      default: undefined,
    },
  },
};
</script>
